import React, { Fragment, useState } from "react";
import BookDemoHelper from "../../Components/BookADemo/Index";

const BookDemoPage = () => {
  return (
    <Fragment>
        <BookDemoHelper />
    </Fragment>
  );
}

export default BookDemoPage;